<div class="echarts"  *ngIf="!noData" id="barCharts" echarts [options]="chartOption" [ngStyle]="{ height: barChartData.pageType === 'home'? '': '133px' }"></div>
<div *ngIf="noData" class="no-data">No Data Available</div>